const host = "api-dev.erpbucket.com";
const port = "80";

export const environment = {
  port,
  host,
  apiMain: `https://${host}`,
  gateway: false,
};
